import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';

// Status to Ant Design color and icon mapping
const STATUS_CONFIG = {
  active:   { color: 'green',   icon: <CheckCircleOutlined /> },
  init:     { color: 'blue',    icon: <SyncOutlined spin /> },
  inactive: { color: 'orange',  icon: <MinusCircleOutlined /> },
  disabled: { color: 'gray',    icon: <CloseCircleOutlined /> },
  warning:  { color: 'gold',    icon: <ExclamationCircleOutlined /> },
  pending:  { color: 'blue',    icon: <ClockCircleOutlined /> },
  trial:  { color: 'purple',  icon: <ClockCircleOutlined /> },
}

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

/**
 * StatusTag component using Ant Design Tag and icons
 * @param {Object} props
 * @param {'active'|'init'|'inactive'|'disabled'|'warning'|'pending'|string} props.status - Status type
 * @param {boolean} [props.showStatus=false] - Whether to show status text
 * @param {React.ReactNode} [props.children] - Optional children to display inside the tag
 */
const StatusTag = ({ status, showStatus = true, children }) => {
  const config = STATUS_CONFIG[status] || { color: '#d9d9d9', icon: <MinusCircleOutlined /> };
  const label = status ? capitalize(status) : '?';

  return (
    <Tag color={config.color}>
      {children}
      {!children && config.icon}
      {showStatus && !children && <span style={{ marginLeft: 6 }}>{label}</span>}
    </Tag>
  );
};

export default StatusTag;